module.exports = __webpack_public_path__ + "static/media/foto8.21a760d9.jpg";